import {Component, Input, OnInit} from '@angular/core';
import {BusinessModel} from '../../../../core-logic/models/business/business-model';
import {UserModel} from '../../../../core-logic/models/user/user-model';
import {NavigationExtras, Router} from '@angular/router';
import {BusinessMemberRoleList} from '../../../../common/enums/business-member-role-list';
import {MemberModel} from '../../../../core-logic/models/business/sub/member/member-model';

@Component({
  selector: 'app-business-member',
  templateUrl: './business-member.component.html',
  styleUrls: ['./business-member.component.scss'],
})
export class BusinessMemberComponent implements OnInit {
  @Input() member: MemberModel;
  @Input() business: BusinessModel;
  @Input() currentUser: UserModel;
  @Input() route: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  @Input() disabled = false;
  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  getMemberRole(): string {
    if (this.member?.user?._id === this.business?.owner._id) { return 'Propriétaire'; }
    const memberRole = this.business.members.find(member => member.user._id === this.member.user._id).role;
    switch (memberRole) {
      case BusinessMemberRoleList.ADMINISTRATOR:
        return 'Administrateur';
      case BusinessMemberRoleList.MANAGER:
        return 'Manageur';
      case BusinessMemberRoleList.WORKER:
        return 'Agent';
    }
  }

  currentUserIsCurrentMember(): boolean {
    return this.currentUser?._id === this.member?.user?._id;
  }

  goToRoute() {
    if (!this.disabled) {
      this.router.navigate(this.route.commands, this.route.extras ?? {state: this.member});
    }
  }

  isSuspended() {
    return this.business?.suspended_work_times.map(suspendedWorkTime => suspendedWorkTime.source_id)
      .includes(this.member.user._id);
  }
}
